export enum CustomPdf {
  DerksenCustomPdf = 'DerksenCustomPdf',
  DerksenCustomPdfV2 = 'DerksenCustomPdfV2',
  SimpleCustomPdf = 'SimpleCustomPdf',
  ExpressCarportCustomPdf = 'ExpressCarportCustomPdf',
  TexwinCustomPdf = 'TexwinCustomPdf',
  IdearoomPdf = 'IdearoomPdf',
  IdearoomPdfSignatureAfterLineItems = 'IdearoomPdfSignatureAfterLineItems',
  WeatherKingCustomPdf = 'WeatherKingCustomPdf',
}
